"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ExpenditureAggregatesFields = void 0;
exports.ExpenditureAggregatesFields = ['calculatedAnnualSpend', 'calculatedAnnualFxSpend', 'mostRecentMonthlySpend', 'last30DaysSpend',
    'mightBeMonthly', 'mightBeYearly', 'oldestTransactionDate', 'newestTransactionDate', 'noTransactionInLastYear',
    'noTransactionInLast14Months', 'spend13to24Months', 'spend25to36Months', 'spendBeforeMonth36'];
